import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VCard,{attrs:{"outlined":""}},[_c(VCardText,{staticClass:"log"},[(_vm.logs.length == 0)?_c('span',[_vm._v("No se ha registrado actividad")]):_vm._e(),_vm._l((_vm.logsLocal),function(log,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(log.fecha)+" - "+_vm._s(log.usuario.nombreCompleto)+" - "+_vm._s(log.accion)+" "),_c('br')])})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }